import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { Services } from './components/Services';
import { EmergencyBand } from './components/EmergencyBand';
import { Craftsmanship } from './components/Craftsmanship';
import { Reviews } from './components/Reviews';
import { QuotePath } from './components/QuotePath';
import { Locations } from './components/Locations';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
const TITLE = 'Kosin’s Glass | Auto, Home, Shower & Commercial Glass';
const DESCRIPTION = 'Kosin’s Glass is a family-owned glass company serving Southeast Michigan since 2000: auto glass and windshields, residential window glass, custom glass shower doors and commercial glazing. Howell showroom, 517-545-7772.';
function setMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    document.title = TITLE;
    setMeta('description', DESCRIPTION);
    setMeta('robots', 'noindex,nofollow');
  }, []);
  return <div id="top" className="w-full bg-white" data-id="element-0" data-mp="2zllf11m4wkmq">
      <a href="#services" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded focus:bg-kosin-charcoal focus:px-4 focus:py-2 focus:text-white" data-id="element-1" data-mp="2zmo89g6xiz5t">
        Skip to main content
      </a>
      <Header data-id="element-2" data-mp="3dle3sre3oqs2" />
      <main data-id="element-3" data-mp="3dlw5i3jj7x7d">
        <Hero data-id="element-4" data-mp="3dlnwwnufze1z" />
        <TrustStrip data-id="element-5" data-mp="3dm5ze27p6oic" />
        <Services data-id="element-6" data-mp="3dii716dzo857" />
        <EmergencyBand data-id="element-7" data-mp="nw2ay2pqvkpi" />
        <Craftsmanship data-id="element-8" data-mp="nuhicimzqbua" />
        <Reviews data-id="element-9" data-mp="nvarfq9f9dfl" />
        <QuotePath data-id="element-10" data-mp="nxwwnj8ubgun" />
        <Locations data-id="element-11" data-mp="sudmchvou39u" />
        <Faq data-id="element-12" data-mp="studdqo0mp7y" />
        <FinalCta data-id="element-13" data-mp="stc864jdl0nw" />
      </main>
      <Footer data-id="element-14" data-mp="swqajcs1h9vc" />
    </div>;
}